"use client";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { Loader } from "../genericComponents/MainLoader/Loader";
import "./index.css";

interface InstructionProps {
  UrlLinks: any;
}

export const Instruction: React.FC<InstructionProps> = ({ UrlLinks }) => {
  const [loader, setLoader] = useState(false);
  const router = useRouter();

  const handleNaviagte = (e: any) => {
    e.preventDefault();
    setLoader(true);
    router.push("/contact-franchise");
  };
  const franchisePoints = [
    "Premium brand language",
    "Operational support",
    "Digital-first demand engine",
  ];
  const growthPillars = [
    {
      label: "Demand",
      value: "Local launch momentum",
      copy: "Growth-focused positioning with stronger digital discovery.",
    },
    {
      label: "Operations",
      value: "Service-ready systems",
      copy: "A cleaner operating model for premium home-service delivery.",
    },
    {
      label: "Brand",
      value: "Modern customer trust",
      copy: "A more elevated experience that feels polished from day one.",
    },
  ];
  return (
    <>
      {loader && <Loader />}
      {UrlLinks?.length > 0 && (
        <Box
          sx={{
            width: "var(--salontym-content-width)",
            margin: "0 auto var(--salontym-section-gap)",
            padding: { xs: "1rem", sm: "1.3rem" },
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(246,251,248,0.92) 100%)",
            borderColor: "none",
            borderRadius: "30px",
            border: "1px solid rgba(18,53,36,0.08)",
            boxShadow: "0 20px 60px rgba(18,53,36,0.08)",
          }}
        >
          <Box sx={{ padding: { xs: "0.1rem", sm: "0.2rem" } }}>
            <Typography className="section-eyebrow">Growth pillars</Typography>
            <Typography
              sx={{
                marginTop: "0.65rem",
                fontFamily: "var(--salontym-font-display)",
                fontSize: { xs: "1.75rem", sm: "2.45rem" },
                lineHeight: 1.02,
                color: "#102117",
                maxWidth: "14ch",
              }}
            >
              Built for modern expansion, not old-school franchise clutter
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" },
                gap: "0.9rem",
                marginTop: "1rem",
              }}
            >
              {growthPillars.map((pillar) => (
                <Box
                  key={pillar.label}
                  sx={{
                    padding: "1rem",
                    borderRadius: "22px",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,247,235,0.96) 100%)",
                    border: "1px solid rgba(18,53,36,0.08)",
                    boxShadow: "0 16px 32px rgba(18,53,36,0.08)",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#1f7a4d",
                      fontSize: "0.78rem",
                      fontWeight: 800,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                    }}
                  >
                    {pillar.label}
                  </Typography>
                  <Typography
                    sx={{
                      marginTop: "0.45rem",
                      color: "#102117",
                      fontFamily: "var(--salontym-font-display)",
                      fontSize: "1.4rem",
                      lineHeight: 1.08,
                    }}
                  >
                    {pillar.value}
                  </Typography>
                  <Typography
                    sx={{
                      marginTop: "0.45rem",
                      color: "#5e6d63",
                      lineHeight: 1.7,
                    }}
                  >
                    {pillar.copy}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      <Box
        className="franchise-shell"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          width: "var(--salontym-content-width)",
          margin: "0 auto var(--salontym-section-gap)",
          padding: { xs: "1.1rem", sm: "1.4rem" },
          borderRadius: "32px",
          background:
            "linear-gradient(135deg, rgba(16,33,23,0.98) 0%, rgba(26,55,38,0.96) 50%, rgba(91,45,31,0.92) 100%)",
          boxShadow: "0 28px 80px rgba(11, 26, 19, 0.18)",
          overflow: "hidden",
          position: "relative",
        }}
        onClick={handleNaviagte}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-4rem",
            right: "-3rem",
            width: "13rem",
            height: "13rem",
            borderRadius: "999px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0) 72%)",
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.15fr 0.95fr" },
            gap: { xs: "1.1rem", md: "1.5rem" },
            width: "100%",
            alignItems: "stretch",
          }}
        >
          <Box
            sx={{
              textAlign: "left",
              padding: { xs: "0.15rem 0.15rem 0", sm: "0.2rem 0.35rem 0" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Box className="section-eyebrow franchise-eyebrow">
                Franchise opportunities
              </Box>
              <Box
                component="h3"
                sx={{
                  margin: "0.75rem 0 0",
                  fontFamily: "var(--salontym-font-display)",
                  fontSize: { xs: "1.9rem", sm: "2.9rem" },
                  lineHeight: 1.02,
                  color: "#fff8f1",
                  maxWidth: "12ch",
                }}
              >
                Build a premium beauty business with SalonTym
              </Box>
              <Box
                component="p"
                sx={{
                  margin: "0.75rem 0 0",
                  color: "rgba(255,248,241,0.72)",
                  lineHeight: 1.75,
                  maxWidth: "42rem",
                }}
              >
                Launch in your market with a stronger service brand, a more modern
                experience layer, and a growth system designed around trust.
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.75rem",
                marginTop: "1rem",
              }}
            >
              {franchisePoints.map((item) => (
                <Box
                  key={item}
                  sx={{
                    padding: "0.8rem 1rem",
                    borderRadius: "999px",
                    background: "rgba(255,255,255,0.1)",
                    border: "1px solid rgba(255,255,255,0.14)",
                    color: "#fff8f1",
                    fontWeight: 700,
                    fontSize: "0.92rem",
                  }}
                >
                  {item}
                </Box>
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: "grid",
              gap: "0.9rem",
              alignContent: "stretch",
            }}
          >
            <Box
              sx={{
                borderRadius: "24px",
                padding: { xs: "1rem", sm: "1.2rem" },
                minHeight: "170px",
                background:
                  "linear-gradient(145deg, rgba(255,255,255,0.13), rgba(255,255,255,0.06))",
                border: "1px solid rgba(255,255,255,0.14)",
                backdropFilter: "blur(12px)",
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: "0.8rem",
              }}
            >
              <Box
                sx={{
                  padding: "0.95rem",
                  borderRadius: "18px",
                  background: "rgba(255,255,255,0.12)",
                }}
              >
                <Typography sx={{ color: "#f7e7bf", fontSize: "0.78rem", fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase" }}>
                  Launch support
                </Typography>
                <Typography sx={{ marginTop: "0.45rem", color: "#fff8f1", fontSize: "1.8rem", fontFamily: "var(--salontym-font-display)" }}>
                  360
                </Typography>
                <Typography sx={{ color: "rgba(255,248,241,0.72)" }}>
                  onboarding, positioning, and customer acquisition thinking
                </Typography>
              </Box>
              <Box
                sx={{
                  padding: "0.95rem",
                  borderRadius: "18px",
                  background: "rgba(255,255,255,0.12)",
                }}
              >
                <Typography sx={{ color: "#f7e7bf", fontSize: "0.78rem", fontWeight: 800, letterSpacing: "0.08em", textTransform: "uppercase" }}>
                  Brand fit
                </Typography>
                <Typography sx={{ marginTop: "0.45rem", color: "#fff8f1", fontSize: "1.8rem", fontFamily: "var(--salontym-font-display)" }}>
                  24/7
                </Typography>
                <Typography sx={{ color: "rgba(255,248,241,0.72)" }}>
                  modern digital storefront presence for your city
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                borderRadius: "24px",
                padding: { xs: "1rem", sm: "1.2rem" },
                background:
                  "linear-gradient(135deg, rgba(255,248,241,0.98), rgba(247,231,191,0.92))",
                color: "#102117",
                boxShadow: "0 24px 50px rgba(11, 26, 19, 0.16)",
              }}
            >
              <Typography sx={{ fontWeight: 800, fontSize: "1.05rem" }}>
                Want to grow with SalonTym?
              </Typography>
              <Typography sx={{ marginTop: "0.4rem", color: "#5e6d63", lineHeight: 1.7 }}>
                Tap here to open the franchise form and start the conversation.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
